import { MAP_TYPE } from 'wix-rich-content-common';
export default function mapStrategy() {
    return {
        config: {
            [MAP_TYPE]: {
                googleMapApiKey: 'AIzaSyC128nl2QIfKdqdQvo3iDo6PKSz_DV4ygI',
            },
        },
    };
}
//# sourceMappingURL=mapStrategy.js.map